import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import NotifyMessagePage from '../../ui-parts/NotifyMessagePage';
import { utility } from '../../utility';

/**
 * AccountActivated Page Component
 */
const AccountActivated = (props) => {
  const screenId = 'MyM907';
  const { controlSettings } = useWebContext(screenId);
  const apiRequest = useMyMApi(screenId);
  const location = useLocation();
  const [message, setMessage] = useState('');

  useEffect(() => {
    const callbackActivateResultContext = (result) => {
      result?.PostResult
        ? setMessage(() => controlSettings.LabelList.lblAccountActivate)
        : setMessage(() => controlSettings.LabelList.lblAccountExpired)
    }
    const search = location.search;
    const queryToken = new URLSearchParams(search);

    apiRequest.requestJson(`api/user-info/activate`, 'POST', callbackActivateResultContext, null, { token: queryToken.get('token') })
  }, []);

  return (
    <NotifyMessagePage>
      <MyMLabel fontSize={"1.25rem"}>
        {message}
        <MyMLink onClick={utility.transferTopPage} sx={{ display: message === "" ? "none" : "inline" }}>{controlSettings.LabelList.lnkTopPage}</MyMLink>
      </MyMLabel>
    </NotifyMessagePage>
  );
}
export default AccountActivated;
